// Icons
import { ReactComponent as arrowLeft } from './assets/arrow-left'
import { ReactComponent as chat } from './assets/chat'
import { ReactComponent as close } from './assets/close'
import { ReactComponent as chevronUp } from './assets/chevron-up'
import { ReactComponent as chevronDown } from './assets/chevron-down'
import { ReactComponent as menu } from './assets/menu'
import { ReactComponent as youtube } from './assets/youtube'
import { ReactComponent as spotify } from './assets/spotify'
import { ReactComponent as tiktok } from './assets/tiktok'
import { ReactComponent as facebook } from './assets/facebook'
import { ReactComponent as instagram } from './assets/instagram'
import { ReactComponent as twitter } from './assets/twitter'
import { ReactComponent as sendChatFill } from './assets/send-chat-fill'
import { ReactComponent as graduation } from './assets/graduation'
import { ReactComponent as pencil } from './assets/pencil'
import { ReactComponent as user } from './assets/user'
import { ReactComponent as arrowsClockwise } from './assets/arrows-clockwise'

export const icons = {
  arrowLeft: { source: arrowLeft },
  chat: { source: chat },
  close: { source: close },
  chevronUp: { source: chevronUp },
  chevronDown: { source: chevronDown },
  menu: { source: menu },
  youtube: { source: youtube },
  spotify: { source: spotify },
  tiktok: { source: tiktok },
  facebook: { source: facebook },
  instagram: { source: instagram },
  twitter: { source: twitter },
  sendChatFill: { source: sendChatFill },
  graduation: { source: graduation },
  pencil: { source: pencil },
  user: { source: user },
  arrowsClockwise: { source: arrowsClockwise },
}
